import sdkUrl from "@/api/sdkurl";

//域名
const domain = "https://hly.hlygames.com";
const webConfig =  {
    //应用名称
    appName: "欢乐游",
    //应用名称
    gameAppName: "欢乐游",
    //网页title
    webTitle: "欢乐游",
    //应用图标
    logoUrl: require("@/assets/logo.png"),
    //圆形logo
    logoRoundUrl: require("@/assets/logo-round.png"),
    //微信公众号
    wechatUrl: require("@/assets/gzh.jpg"),
    //应用二维码
    appqrUrl: "",
    //icp备案
    icp: "赣ICP备2025065049号-1",
    //公安备案
    publicSecurity: "",
    //版权所有
    copyright: "copyright © 2026 hly.hlygames.com All Rights Resered.",
    //公司地址
    address: "江西省抚州市东乡区城东物流园F10栋12房、13房",
    //公司名称
    companyName: "抚州市东乡区欢乐游信息技术店（个人独资）",
    //公司名称
    copyrightCompany: "欢乐游平台 版权所有",
    //app备案
    appRecord: "",
    //用户协议
    agreement :  domain + "/static/agreement/user.html",
    //隐私政策
    privacy :  domain + "/static/agreement/privacy.html",
    //QQ客服
    qqkfList: [
         //{"info": "1416991369", "worktime": ""}
    ],
    wxkfList: [
        {"info": "https://work.weixin.qq.com/kfid/kfc365511be9209c54e", "worktime": "09:00-22:00"}
    ],
    telkfList: [
        // {"info": "", "worktime": ""}
    ],
    //平台币名称
    coinName: "平台币",
    bindCoinName: '绑币',
    //游戏加速器地址
    speedUrl: domain + "/static/speed/a.html?genCode=true",
    //sdkweb地址
    sdkUrl: sdkUrl,
    //默认搜索游戏名
    defaultSearchName: "斗罗大陆",
    hotSearchName: ["斗罗大陆"],
    redirectUri: domain + "/#/rechargeWeiXin",
    appid: "wx4d86611b3f48c5e7",
    drawUrl: domain + '/welfare/',
    gameUrlMiddle: "/h5/",
}

export default webConfig